<template>
  <div class="results-controls">
    <div class="results-controls__heading">
      <slot name="heading"></slot>
    </div>

    <div class="results-controls__actions">
      <sorting-select :sort="sort" @order="(value) => $emit('order', value)" />
      <vb-button
        class="results-controls__filters-trigger"
        :vb_options="{ text: 'Filtri', icon: 'filter', size: 'sm' }"
        @click="$emit('toggle-filters')"
      />
    </div>
  </div>
</template>

<script>
  import SortingSelect from './sorting-select.vue';

  export default {
    name: 'results-controls',

    components: {
      'sorting-select': SortingSelect,
    },

    props: {
      sort: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style lang="scss" scoped>
  .results-controls {
    display: flex;
    flex-direction: column;
    gap: $grid-gutter-width / 3;
    margin-bottom: $grid-gutter-width / 2;

    @include media-breakpoint-up(md) {
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
      gap: $grid-gutter-width / 2;
    }

    &__heading {
      ::v-deep p {
        margin-bottom: 0;
      }
    }

    &__actions {
      display: flex;
      align-items: center;
      gap: $grid-gutter-width / 3;
      flex-shrink: 0;
    }

    &__filters-trigger {
      display: flex;
      align-items: center;
      line-height: normal;

      @include media-breakpoint-up(xl) {
        display: none;
      }
    }
  }
</style>
